import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { InputEl } from "common/components/input";
import { ConfirmEl } from "common/components/confirm";
import { SpinnerEl } from "common/components/spinner";
import { TooltipEl } from "common/components/tooltip";
import { getFormattedPropertyName, getRawPropertyValue } from "common/util/format-property";
import { FormattedPropertyMixin } from "common/widgets/profile-activity/formatted-property/template";
import { ButtonTheme } from "common/components/button/constants";
import { Placement } from "common/components/tooltip/types";
import { THEME } from "common/components/confirm/types";
export function template() {
  const { editValue, isEditing, isConfirmingDelete } = this.state;
  const {
    "match-parts": matchParts,
    property,
    loading,
    "sidebar-mode": sidebarMode,
    "can-write-profile": hasWriteProfilePermission
  } = this.attrs();
  const propertyEditDisabled = Array.isArray(getRawPropertyValue(property));
  const EditingProperty = () => {
    const controlBarElement = loading ? /* @__PURE__ */ jsx(SpinnerEl, null) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ButtonEl, {
      sel: ".new-property-button",
      attrs: {
        theme: ButtonTheme.Tertiary
      },
      on: {
        click: this.helpers.handleCancelPropertyEdit
      }
    }, "Cancel"), /* @__PURE__ */ jsx(ButtonEl, {
      sel: ".new-property-button",
      attrs: {
        theme: ButtonTheme.Primary
      },
      on: {
        click: this.helpers.handleSavePropertyValue
      }
    }, "Save"));
    return /* @__PURE__ */ jsx("div", {
      sel: ".editing-property"
    }, /* @__PURE__ */ jsx(InputEl, {
      sel: ".value-input",
      attrs: {
        label: getFormattedPropertyName(property)
      },
      props: {
        value: editValue
      },
      on: {
        input: this.helpers.handleUpdatePropertyValue
      },
      hook: { insert: this.helpers.inputInserted }
    }), /* @__PURE__ */ jsx("div", {
      sel: ".confirmation-buttons"
    }, controlBarElement));
  };
  const PropertyControls = () => {
    if (loading) {
      return /* @__PURE__ */ jsx("div", {
        sel: ".loading-spinner-wrapper"
      }, /* @__PURE__ */ jsx(SpinnerEl, null));
    }
    if (sidebarMode) {
      return null;
    }
    return /* @__PURE__ */ jsx("div", {
      sel: ".hover-button-wrapper"
    }, !hasWriteProfilePermission && /* @__PURE__ */ jsx(TooltipEl, {
      attrs: { placement: Placement.Left }
    }, "You don't have permission to edit."), hasWriteProfilePermission && propertyEditDisabled && /* @__PURE__ */ jsx(TooltipEl, {
      attrs: { placement: Placement.Left }
    }, "Editing list properties is disabled."), /* @__PURE__ */ jsx(ButtonEl, {
      attrs: {
        disabled: propertyEditDisabled || !hasWriteProfilePermission,
        theme: ButtonTheme.Tertiary,
        icon: `edit`,
        tabindex: 1
      },
      on: {
        click: this.helpers.handleEditProperty
      }
    }), /* @__PURE__ */ jsx(ButtonEl, {
      attrs: {
        disabled: !hasWriteProfilePermission,
        theme: ButtonTheme.Tertiary,
        icon: `trashcan`,
        tabindex: 2
      },
      on: {
        click: this.helpers.handleDeleteButton
      }
    }));
  };
  const ViewProperty = () => /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".property-wrapper"
  }, /* @__PURE__ */ jsx(FormattedPropertyMixin, {
    layout: sidebarMode ? this.helpers.FormattedPropertyLayout.Horizontal : this.helpers.FormattedPropertyLayout.Vertical,
    property,
    matchParts
  })), /* @__PURE__ */ jsx(PropertyControls, null));
  const ConfirmDelete = () => /* @__PURE__ */ jsx(ConfirmEl, {
    attrs: {
      theme: THEME.DELETE,
      "confirm-button-label": `Delete Property`,
      open: true
    },
    on: {
      submit: this.helpers.handleModalButton
    }
  }, /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-confirm-title"
  }, "Delete '", getFormattedPropertyName(property), "' From Profile?"), /* @__PURE__ */ jsx("div", {
    sel: ".mp-confirm-description"
  }, "This property will no longer show on this profile.")));
  return /* @__PURE__ */ jsx("div", {
    sel: ".formatted-property",
    class: {
      "edit-disabled": propertyEditDisabled || !hasWriteProfilePermission
    },
    on: {
      click: isEditing || propertyEditDisabled || !hasWriteProfilePermission || sidebarMode ? null : this.helpers.handleEditProperty
    }
  }, isEditing ? /* @__PURE__ */ jsx(EditingProperty, null) : /* @__PURE__ */ jsx(ViewProperty, null), isConfirmingDelete && /* @__PURE__ */ jsx(ConfirmDelete, null));
}
